// ======================================================================
// File Name       : ContentVideoAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import AWS from 'aws-sdk';
import Evaporate from 'evaporate';
import { CONTENT_VIDEO_SEARCH, VIDEO_URL } from '../../constants/ActionTypes';
import * as ActionTypes from '../../constants/actionTypes/content';
import { SHOW_MESSAGE } from '../../constants/actionTypes/message';
import {
  AWS_BUCKET,
  AWS_REGION,
  MESSAGE_TYPE,
  RETURN_MAX_NUM,
  S3_CACHE_HOURS_AGO,
  SELECT_TARGET_DATA
} from '../../constants/index';
import { AWS_UPLOADS } from '../../constants/LocalStorageConstants';
import { MSG_UPLOAD_VIDEO_FAIL } from '../../constants/MessageTemplate';
import { CONTENT_VIDEO_LIST } from '../../constants/PathConstants';
import store from '../../store';
import { commonCallApi } from '../../utils/ApiUtils';
import { downloadFile } from '../../utils/index';
import { sendGetVideoListFileRequest, sendImportVideoRequest } from '../httpRequests/content';
import { getPlayer, getUploadSignatureRequest, getVideos } from '../httpRequests/video';


/**
 * Store content video list
 * @param {*} contentInfo
 */
function receiveContentVideoList(videoInfo) {
  return {
    type: CONTENT_VIDEO_SEARCH,
    videoInfo,
  };
}

/**
 * Action content video get list
 * @param {*} searchInfo
 */
export function getVideoList(searchInfo) {
  return dispatch => commonCallApi({
    path: 'video/GetList',
    data: searchInfo,
    institutionId: 1,
  }).then((camelizeJson) => {
    if (searchInfo && searchInfo.selectTargetData === SELECT_TARGET_DATA.CSV) {
      const url = camelizeJson && camelizeJson.csvfileUrl ? camelizeJson.csvfileUrl : null;
      downloadFile(url);
    } else {
      dispatch(receiveContentVideoList(camelizeJson));
    }
  });
}

export function contentVideoEdit(searchInfo, history, uploadFile) {
  return (dispatch) => {
    commonCallApi({
      path: 'video/Edit',
      data: searchInfo,
      institutionId: 1,
    }).then((camelizeJson) => {
      if (uploadFile && camelizeJson) {
        camelizeJson.uploadFile = uploadFile;
        // initailize params to upload video to S3
        const params = {
          contentTemporaryUploadUrl: camelizeJson.contentTemporaryUploadUrl,
          contentSecernId: camelizeJson.contentSecernId,
          uploadFile,
          accessKeyId: camelizeJson.accessKeyId,
          securityToken: camelizeJson.securityToken,
        };
        dispatch(uploadVideoToS3(params));
      } else {
        history.push(CONTENT_VIDEO_LIST);
      }
    });
  };
}
function uploadVideoToS3(params) {
  return (dispatch, getState) => {
      // get video signature response
    let contentTemporaryUploadUrl = params.contentTemporaryUploadUrl;
    if (contentTemporaryUploadUrl.endsWith('/')) {
      contentTemporaryUploadUrl = contentTemporaryUploadUrl.slice(0, -1);
    }
    const { accessKeyId, securityToken } = params;
      // video progress params
    const config = {
      aws_url: contentTemporaryUploadUrl,
      aws_key: accessKeyId,
      bucket: AWS_BUCKET,
      awsRegion: AWS_REGION,
      cloudfront: true,
      computeContentMd5: true,
      cryptoMd5Method: data => AWS.util.crypto.md5(data, 'base64'),
      cryptoHexEncodedHash256: data => AWS.util.crypto.sha256(data, 'hex'),
      logging: false,
      s3FileCacheHoursAgo: S3_CACHE_HOURS_AGO,
      mockLocalStorage: true,
      allowS3ExistenceOptimization: true,
      customAuthMethod: customAuth,
      signParams: {
        contentSecernId: params.contentSecernId,
      },
    };
    const videoProgress = {
      showProgressBar: false,
      percentage: 0,
      showReasonModal: false,
      showSuccessfulModal: false,
      isServerErr: false,
      reason: '',
    };
    
    return Evaporate.create(config).then((evaporate) => {
      //   set config for s3 upload and send request.
      const targetFile = params.uploadFile;
      const exs = targetFile.name.split('.').pop();
      const addConfig = {
        name: params.contentSecernId.concat('.', exs),
        file: targetFile,
        xAmzHeadersCommon: securityToken ? { 'x-amz-security-token': securityToken } : undefined,
        xAmzHeadersAtInitiate: securityToken ? { 'x-amz-security-token': securityToken } : undefined,
        progress: (progressValue) => {
          // update video progress
          const { content } = getState();
          const isError = content.isCancelUpload || (content.videoProgress.reason !== '');
          if (!isError) {
            const percentage = parseInt(Math.round(progressValue * 100), 10);
            videoProgress.percentage = percentage;
            videoProgress.showProgressBar = true;
            videoProgress.handleCancelled = () => evaporate.cancel();
            dispatch(updateVideoProgress(videoProgress));
          }
        },
      };

      evaporate.add(addConfig)
      .then(
        () => {
          videoProgress.showProgressBar = false;
          videoProgress.showSuccessfulModal = true;
          dispatch(updateVideoProgress(videoProgress));
          const uploads = JSON.parse(localStorage.getItem(AWS_UPLOADS) || '{}');
          for (const key in uploads) {
            if (uploads[key] && uploads[key].awsKey &&
                uploads[key].awsKey.startsWith(params.contentSecernId.concat('.'))) {
              if (uploads[key].completedAt) {
                delete uploads[key];
              }
            }
          }
          localStorage.setItem(AWS_UPLOADS, JSON.stringify(uploads));
        },
      (reason) => {
        const { content } = getState();
        videoProgress.showReasonModal = !content.isCancelUpload;
        videoProgress.showProgressBar = false;
        if (!content.videoProgress.isServerErr) {
          videoProgress.reason = reason;
        } else {
          videoProgress.reason = content.videoProgress.reason;
        }
        dispatch(updateVideoProgress(videoProgress));
      });
    },
  );
  };
}


function customAuth(_signParams, _signHeaders, stringToSign, dateString) {
  _signParams.toSign = stringToSign;
  _signParams.signDatetime = dateString;
  return getUploadSignatureRequest(_signParams).then(response => response.uploadSignature).catch((err) => {
    handleUploadErr(err);
  });
}
/**
 * Store video
 * @param {*} contentInfo
 */
function receiveVideo(videoUrl) {
  return {
    type: VIDEO_URL,
    videoUrl,
  };
}
function handleUploadErr(err) {
  const { content } = store.getState();
  const videoProgress = {
  };
  if (!content.isCancelUpload) {
    if (err.message) {
      if (!err.statusCd) {
        videoProgress.reason = MSG_UPLOAD_VIDEO_FAIL;
        const messageInfo = {
          message: [MSG_UPLOAD_VIDEO_FAIL],
          messageType: MESSAGE_TYPE.error,
        };
        store.dispatch({ type: SHOW_MESSAGE, ...messageInfo });
      } else {
        videoProgress.reason = err.message[0];
      }
      videoProgress.isServerErr = true;
      videoProgress.showReasonModal = true;
    }
    content.videoProgress.handleCancelled();
  }
  store.dispatch(updateVideoProgress(videoProgress));
}
export function updateVideoProgress(data) {
  return {
    type: ActionTypes.UPDATE_VIDEO_PROGRESS,
    data,
  };
}

// #6310
export function recieveCancelUpload(data) {
  return {
    type: ActionTypes.CANCEL_UPLOAD,
    data,
  };
}
export function getVideo(videoInfo) {
  return (dispatch) => {
    commonCallApi({
      path: 'video/GetVideo',
      data: videoInfo,
      institutionId: 1,
    }).then((camelizeJson) => {
      dispatch(receiveVideo(camelizeJson));
    });
  };
}

function receiveData(resData, type) {
  return {
    type,
    resData,
  };
}

export function getListImportedFile(options) {
  return (dispatch) => {
    const PARAM_DEFAULT = {
      returnMaxNum: RETURN_MAX_NUM,
    };
    sendGetVideoListFileRequest(PARAM_DEFAULT, options).then((resdata) => {
      dispatch(receiveFileList(resdata));
    });
  };
}

function receiveFileList({ recordNum, importResultList }) {
  return {
    type: ActionTypes.RECEIVED_VIDEO_FILE_LIST,
    recordNum,
    importResultList,
  };
}

export function importVideoList(data, options) {
  return (dispatch) => {
    sendImportVideoRequest(data, options).then((resdata) => {
      dispatch(receiveData(resdata, ActionTypes.IMPORT_VIDEO_LIST));
    });
  };
}

// START #6305
export function getVideoDetail(contentSecernId) {
  return async (dispatch) => {
    const videoDetailParams = {
      searchInfo: {
        contentSecernIdList: [contentSecernId],
      },
      selectTargetData: 0,
    };
    const result = await getVideos(videoDetailParams);
    dispatch(receiveContentVideoList(result));
  };
}

export function getVideoUrl(params) {
  return async (dispatch) => {
    const playerResult = await getPlayer(params);
    dispatch(receiveVideo(playerResult));
  };
}
// END #6305
